// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_8g556","visuallyhidden":"_1GKj9","hide-text":"_1s3Pq","center":"_2USq7","noprint":"_3F3Fx","subheading":"_3v0mO"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-subheading/styles/Subheading.scss
 ** module id = 951
 ** module chunks = 1
 **/